import { z } from "zod";

import { baseApiResponse } from "./BaseApiResponse";

export enum TransactionTypes {
	DEPOSIT = "DEPOSIT",
	WITHDRAW = "WITHDRAW",
	TRANSFER = "TRANSFER"
}

export enum AdditionalParamKeys {
	ACCOUNT_NUMBER = "accountNumber",
	STATE = "state",
	BANK_CODE = "bank_code",
	TAX_ID = "tax_id",
	WITHDRAW_ACCOUNT = "withdraw_account",
	CARD_NUMBER = "Card_Number"
}

const currencyInfoResolver = z.object({
	deposit: z.object({
		min: z.number(),
		max: z.number()
	}),
	withdraw: z.object({
		min: z.number(),
		max: z.number()
	})
});

const showForResolver = z.union([z.literal("all"), z.literal("All"), z.literal("withdraw"), z.literal("deposit")]);

const additionalParamsResolver = z.object({
	label: z.string(),
	showfor: showForResolver,
	skipsaving: z.string().optional()
});

export type PaymentSystemAdditionalParamsModel = z.infer<typeof additionalParamsResolver>;

const additionalParamsRecordResolver = z.record(additionalParamsResolver);

const paymentSystemResolver = z.object({
	id: z.string(),
	name: z.string(),
	name_withdraw: z.string(),
	description: z.string(),
	description_withdraw: z.string(),
	additional: z.string(),
	showfor: showForResolver,
	cryptoInvoice: z.boolean().optional(),
	image: z.string().url(),
	image_withdraw: z.string().url(),
	default_images: z.array(z.string()),
	optional_checks: z.array(z.unknown()),
	alias: z.string().optional(),
	currencies: z.array(z.string()),
	required: z.array(z.string()),
	required_withdraw: z.array(z.string()),
	tags: z.array(z.unknown()),
	hostedFields: z.array(z.unknown()),
	customParams: z.array(z.unknown()),
	depositFeatures: z.string(),
	preselectedDepositAmounts: z.array(z.unknown()),
	preselectedWithdrawAmounts: z.array(z.unknown()),
	disable_amount: z.boolean(),
	message: z.string(),
	allowiframe: z.number(),
	appearance: z.string(),
	lastAccounts: z.array(z.unknown()),
	lastAccountsObj: z.array(z.unknown()),
	depositMin: z.number(),
	depositMax: z.number(),
	withdrawMin: z.number(),
	withdrawMax: z.number(),
	currencyInfo: z.record(currencyInfoResolver),
	additionalParams: additionalParamsRecordResolver.or(additionalParamsRecordResolver.array())
});

export type PaymentSystemModel = z.infer<typeof paymentSystemResolver>;

export const listPaymentSystemsResult = baseApiResponse.omit({ data: true }).extend({
	data: paymentSystemResolver.array()
});

export type ListPaymentSystemsResult = z.infer<typeof listPaymentSystemsResult>;
